// extracted by mini-css-extract-plugin
export default {"dealSection":"DealsOfTheDay_dealSection__lAjXf","dealTile":"DealsOfTheDay_dealTile__00CTL"};